<template>
    <div id="offerRequestSummary">
        <!-- Diese Seite besteht aus 5 Karten:
         - Meine Daten
         - Meine Vertragsdetails
         - Beratung
         - Überprüfen
         - Abschließen
    -->
        <!-- 1. MEINE DATEN -->
        <v-card color="#CCD5ED" class="mb-2">
            <v-card-title class="pb-0">
                <div class="subcard-header headline" color="primary">
                    <v-icon>person</v-icon> Meine Daten
                </div>
            </v-card-title>
            <v-card-text>
                <v-layout class="mb-2" align-start justify-start row>
                    <v-flex xs12> Name/Adresse:<br>
                        <span v-html="address"></span>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2" align-start justify-start row>
                    <v-flex xs12> Geburtsdatum:<br>
                        <span v-html="birthdate"></span>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2" align-start justify-start row>
                    <v-flex xs12> Telefon:<br>
                        <span v-html="phone"></span>
                    </v-flex>
                </v-layout>
                <v-layout class="mb-2" align-start justify-start row>
                    <v-flex xs12> E-Mailadresse:<br>
                        <span v-html="email"></span>
                    </v-flex>
                </v-layout>
                <v-layout align-start justify-start row>
                    <v-flex xs12> IBAN:<br>
                        <span class="text-smaller" v-html="iban"></span>
                    </v-flex>
                </v-layout>
            </v-card-text>
        </v-card>

        <!-- 2. MEINE VERTRAGSDETAILS -->
        <v-card color="#CCD5ED" class="mb-2">
            <v-card-title class="pb-0">
                <div class="subcard-header headline" color="primary">
                    <v-icon>list</v-icon> Meine Vertragsdetails
                </div>
            </v-card-title>
            <v-card-text class="">
                <v-layout align-start justify-start row>
                    <v-flex xs6> Beginn:</v-flex>
                    <v-flex xs6>{{ begin }}</v-flex>
                </v-layout>
                <v-layout align-start justify-start row>
                    <v-flex xs6> Ablauf:</v-flex>
                    <v-flex xs6>{{ end }}</v-flex>
                </v-layout>
                <v-layout align-start justify-start row>
                    <v-flex xs6>Gegenstände:</v-flex>
                    <v-flex xs6>
                        <ul>
                            <li v-for="product in products">
                                <span>{{ product.label }}</span>
                            </li>
                        </ul>
                    </v-flex>
                </v-layout>
                <v-layout align-start justify-start row>
                    <v-flex xs6> Mein Beitrag:</v-flex>
                    <v-flex xs6>{{ price }} monatlich</v-flex>
                </v-layout>
                <!-- Online-Geschäftsstelle, Bestandsnummer noch nicht vorhanden -->
                <v-layout v-if="askForSalesAgentNr" align-start justify-start row>
                    <v-flex xs6>Bestandsnummer:</v-flex>
                    <v-flex xs6>
                        <v-text-field class="bold-placeholder" v-model="salesagent_nr" label="Bestandsnummer"
                            placeholder="nicht vorhanden - bitte geben Sie Ihre Bestandsnummer erneut ein"></v-text-field>
                    </v-flex>
                </v-layout>
                <!-- Online-Geschäftsstelle, Bestandsnummer vorhanden -->
                <v-layout v-if="showSalesAgentNr" align-start justify-start row>
                    <v-flex xs6>Bestandsnummer:</v-flex>
                    <v-flex xs6>{{ salesagent_nr }}</v-flex>
                </v-layout>

            </v-card-text>
        </v-card>

        <!-- 3. BERATUNG -->
        <v-card color="#CCD5ED" class="mb-2">
            <v-card-title class="pb-0">
                <div class="subcard-header headline" color="primary">
                    <v-icon>people_outline</v-icon> Beratung
                </div>
            </v-card-title>

            <v-card-text>
                <p class="subheading">Weiter ohne Beratung</p>
                <p>
                    Wir weisen Sie darauf hin, dass sich ein Verzicht nachteilig auf Ihre Möglichkeit auswirken kann,
                    Schadenersatzansprüche wegen Verletzung der Beratungs- und Dokumentationspflicht geltend zu
                    machen.
                </p>
                <p>
                    <v-checkbox v-model="beratungverz" ref="beratungverz"
                        :rules="[v => !!v || 'Ohne Beratungsverzicht ist ein Online-Abschluss nicht möglich.']"
                        label="Ja, ich verzichte auf eine Beratung und möchte weiter zum Antrag. Der Beratungsverzicht wird dokumentiert und mir per Mail zur Verfügung gestellt."
                        required></v-checkbox>


                </p>
                <p class="subheading">
                    Ich möchte eine Beratung
                </p>
                <!-- Result of search dialog: selected agency -->
                <div v-show="salesagent_nr !== '' && selectedAgency !== null">
                    <v-container fluid class="pa-0 ma-0 my-2">
                        <v-layout row wrap>
                            <v-card class="agency-card" elevation="3" color="transparent">
                                <v-container fluid>
                                    <v-layout row wrap>
                                        <v-flex xs12 sm4>
                                            <v-img :src="selectedAgency.imageUrl" position="left top" contain></v-img>
                                        </v-flex>
                                        <v-flex xs12 sm8>
                                            <v-card-text class="p-no-bottom-margin"
                                                v-html="selectedAgency.shortDescription">
                                            </v-card-text>
                                        </v-flex>
                                    </v-layout>
                                </v-container>

                            </v-card>
                        </v-layout>
                    </v-container>
                </div>
                <p v-show="salesagent_nr === ''">
                    Wir unterstützen Sie gerne dabei, die für Sie passende Versicherung zu finden. Wählen Sie dazu
                    eine der <a href="https://www.oeffentliche.de/content/beratersuche/" target="_blank">folgenden
                        Kontaktmöglichkeiten</a>.
                </p>
                <p v-show="salesagent_nr !== '' && selectedAgency === null">
                    Wir unterstützen Sie gerne dabei, die für Sie passende Versicherung zu finden. Wählen Sie dazu
                    eine der <a href="https://www.oeffentliche.de/content/service/kontakt/" target="_blank">folgenden
                        Kontaktmöglichkeiten</a>.
                </p>
            </v-card-text>
        </v-card>


        <!-- 4. ÜBERPRÜFEN -->
        <v-card color="#CCD5ED" class="mb-2">
            <v-card-title class="pb-0">
                <div class="subcard-header headline" color="primary">
                    <v-icon>search</v-icon> Überprüfen
                </div>
            </v-card-title>
            <v-card-text>
                <p class="subheading">
                    Ohne Risiko: 14 Tage Widerrufsrecht
                </p>
                <p>
                    Den Versicherungsschutz bei uns online zu beantragen ist für Sie völlig ohne Risiko. Sie können den
                    Vertragsabschluss bis zum Ablauf von 14 Tagen nach Zugang Ihres Versicherungsscheins gegenüber der
                    Öffentlichen Sachversicherung widerrufen. Über Ihr Widerrufsrecht werden Sie in den Vertragsbestimmungen
                    ausführlich informiert.
                </p>
                <p class="subheading">
                    Vertragsgrundlagen und –informationen
                </p>
                <p>
                    Bitte speichern Sie die folgenden Unterlagen und lesen diese sorgfältig durch.
                </p>
                <p>
                <ul>
                    <li><a :href="link_HUS_IPID_VG" target="_blank">Produktinformationsblatt</a></li>
                    <li><a :href="link_HUS_BVG" target="_blank">Versicherungsbedingungen</a></li>
                    <li><a :href="link_Datenschutz_und_HIS" target="_blank">Information zur Verwendung Ihrer Daten</a></li>
                </ul>
                </p>

                <p class="subheading">
                    Wir möchten Sie gern auf dem Laufenden halten
                </p>
                <p>
                    Ich bin damit einverstanden, dass die Öffentliche Versicherung Braunschweig und ihre Vertriebspartner
                    meine Daten zum Zwecke nutzt, um mich auf aktuelle Entwicklungen meiner Versicherungen und interessante
                    Angebote aufmerksam zu machen.
                    In diesen Fällen möchte ich auf elektronischem Wege (z.B. per E-Mail, Fax, SMS oder Messenger)
                    kontaktiert werden.<br>
                    Diese Einwilligung ist freiwillig und kann von mir jederzeit gegenüber der Öffentlichen und ihren
                    Vertriebspartnern widerrufen werden.

                    <v-checkbox v-model="werbung" label="Ja, Sie dürfen mich informieren"></v-checkbox>
                </p>
            </v-card-text>
        </v-card>


        <!-- 5. ABSCHLUSS -->
        <v-card color="#CCD5ED" class="mb-2">
            <v-card-title class="pb-0">
                <div class="subcard-header headline" color="primary">
                    <v-icon>check_circle_outline</v-icon> Abschließen
                </div>
            </v-card-title>
            <v-card-text>
                <p>
                    Ja, ich habe die oben aufgeführten Vertrags&shy;grundlagen und –informationen, die wir Ihnen zusätzlich
                    per E-Mail zusenden, erhalten, zur Kenntnis genommen und stimme diesen zu.
                </p>
                <p>
                    Ja, ich willige hiermit ausdrücklich ein, dass alle meine im Zuge dieses Vertragsabschlusses von mir zur
                    Verfügung gestellten persönlichen Daten wie in den Informationen zur Verwendung Ihrer Daten beschrieben
                    erhoben, verarbeitet und genutzt werden.
                </p>
                <v-checkbox v-model="agb" ref="agb"
                    :rules="[v => !!v || 'Bitte stimmen Sie den Vertragsgrundlagen und –informationen zu.']" required
                    label="Ich stimme zu und erhalte die Vertragsgrundlagen und –informationen per E-Mail."></v-checkbox>


                <!-- Meldungen im Zshg. mit den Schnittstellen -->
                <v-dialog v-model="checkServiceRunning" hide-overlay persistent width="300">
                    <v-card color="">
                        <v-card-text>
                            Die Angaben werden geprüft.
                            <v-progress-linear indeterminate color="secondary" class="mb-0"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="sendServiceRunning" hide-overlay persistent width="300">
                    <v-card color="">
                        <v-card-text>
                            Ihr Antrag wird übertragen. Je nach Anzahl der Fotos und Verbindungsqualität kann das etwas
                            dauern. Bitte schließen Sie das Browserfenster während der Übertragung nicht.<br>
                            Wenn die Übertragung erfolgreich war, erhalten Sie an dieser Stelle eine Bestätigung!
                            <v-progress-linear indeterminate color="secondary" class="mb-0"></v-progress-linear>
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <v-dialog v-model="showErrorMessage" hide-overlay scrollable width="300">
                    <v-card color="">
                        <v-toolbar dark color="primary lighten-1">
                            <v-toolbar-title>Achtung</v-toolbar-title>
                            <v-spacer></v-spacer>
                            <v-btn icon dark @click="showErrorMessage = false">
                                <v-icon>close</v-icon>
                            </v-btn>
                        </v-toolbar>
                        <v-card-text>
                            {{ errorMessage }}
                        </v-card-text>
                    </v-card>
                </v-dialog>
                <!-- Meldungen Ende -->

                <v-btn dark color="cta" @click.stop="submitIfValid" :disabled="isSubmitting">
                    Jetzt verbindlich abschließen
                </v-btn>

                <v-tooltip v-if="false" bottom>
                    <template v-slot:activator="{ on }">
                        <v-btn v-on="on" :disabled="false" dark color="grey"
                            @click="testPolicy">
                            TESTHILFE: Police direkt
                        </v-btn>
                    </template>
                    <span>Kein CheckService, Police wird generiert, kein SendService</span>
                </v-tooltip>


            </v-card-text>
        </v-card>

        <v-dialog max-width="350px" class="dialog-width" v-model="showAgbRequiredDialog">
            <v-card>
                <v-toolbar dark color="primary lighten-1">
                    <v-toolbar-title>Vertragsgrundlagen</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showAgbRequiredDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p>
                        Bitte beachten Sie die Hinweise unter 'Abschließen' und geben Sie Ihr Einverständnis!
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="primary" @click="showAgbRequiredDialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>


        <v-dialog max-width="350px" class="dialog-width" v-model="showVerzichtRequiredDialog">
            <v-card>
                <v-toolbar dark color="primary lighten-1">
                    <v-toolbar-title>Beratungsverzicht</v-toolbar-title>
                    <v-spacer></v-spacer>
                    <v-btn icon dark @click="showVerzichtRequiredDialog = false">
                        <v-icon>close</v-icon>
                    </v-btn>
                </v-toolbar>
                <v-card-text>
                    <p>
                        Bitte beachten Sie den Hinweis im Bereich 'Beratung' und geben Sie Ihr Einverständnis!
                    </p>
                </v-card-text>
                <v-card-actions>
                    <v-btn class="primary" @click="showVerzichtRequiredDialog = false">OK</v-btn>
                </v-card-actions>
            </v-card>
        </v-dialog>

        <v-card color="#CCD5ED" class="mb-2">
            <v-card-actions>
                <v-flex xs12 class="mt-2 mb-1">
                    <v-btn color="primary" @click="$emit('coming-back')">
                        <v-flex xs2>
                            <v-icon left>arrow_left</v-icon>
                        </v-flex>
                        <v-flex xs10>
                            zurück
                        </v-flex>
                    </v-btn>
                </v-flex>
            </v-card-actions>
        </v-card>

    </div>
</template>

<script>
import VisService from '../services/VisService';
import PdfService from '../services/PdfService';
import { mapGetters } from "vuex";
import { postGaMessage } from "@/stores/modules/ga";

import { createPdf } from "pdfmake/build/pdfmake";
import pdfMake from 'pdfmake'
import vfsFonts from 'pdfmake/build/vfs_fonts'

import { documentDefinition } from "../libs/pdf/pdfmakeDocDefs";
import { footerFunction } from "../libs/pdf/widgets/footer";
import { headerFunction } from "../libs/pdf/widgets/header";
import { add, format, parseISO } from 'date-fns';

export default {
    name: "FormOfferRequestSummary",
    data() {
        return {
            valid: false,
            sendServiceRunning: false,
            checkServiceRunning: false,
            showErrorMessage: false,
            errorMessage: "",
            showAgbRequiredDialog: false,
            showVerzichtRequiredDialog: false,
            isSubmitting: false
        }
    },
    computed: {
        validDebug() {
            return (this.beratungverz == true && this.agb == true);
        },
        link_HUS_IPID_VG() {
            return this.$store.state.work.links.HUS_IPID_VG;
            // return "https://bitve190.vis-extranet.de:31443/FormularDBNew/Suche?unid=5F74F6561EA2D309C12583F2004606B8&dok=HUS_IPID_VG_2019-05.pdf&";
        },
        link_HUS_BVG() {
            return this.$store.state.work.links.HUS_BVG;
            // return "https://bitve190.vis-extranet.de:31443/FormularDBNew/Suche?unid=5CF67276052E7F02C12583F20045C47F&dok=HUS_BVG_2019-05.pdf&";
        },
        link_Datenschutz_und_HIS() {
            return this.$store.state.work.links.Datenschutz_und_HIS;
            // return "https://bitve190.vis-extranet.de:31443/FormularDBNew/Suche?unid=CAD9CBB5251E8C82C1257E2A0026B46C&dok=Datenschutzhinweise%20Oeffentliche%20und%20Datenaustausch%20mit%20HIS.pdf";
        },
        begin() {
            return this.moment(this.$store.getters['work/getContractBegin']).locale('de').format('DD.MM.YYYY');
        },
        end() {
            return this.moment(this.$store.getters['work/getContractBegin']).add(1, 'year').locale('de').format('DD.MM.YYYY');
            // return this.begin.substr(0,8)+(Number(this.begin.substr(-2,2))+1);
        },
        price() {
            return this.$store.getters['work/getPriceTotal'] + ",00 Euro";
        },
        products() {
            return this.$store.getters['work/getSelectedProducts'];
        },
        address() {
            return this.$store.getters['work/getAddress'];
        },
        birthdate() {
            return this.moment(this.$store.getters['work/getBirthdate']).locale('de').format('DD.MM.YYYY');
        },
        phone() {
            if (this.$store.getters['work/getPhone'] == "") {
                return "Keine Angabe";
            }
            return this.$store.getters['work/getPhone'];
        },
        email() {
            return this.$store.getters['work/getEmail'];
        },
        iban() {
            let iban = this.$store.getters['work/getIban'];
            if (iban.length > 5) {
                let bban = this.IBAN.toBBAN(iban, ", Kontonummer: ");
                return iban + "<div>(<span style='font-size:inherit;'>BLZ: " + bban + "</span>)</div>";
            }
            return iban;
        },
        beratungverz: {
            get() {
                return this.$store.state.work.forxchange.offerRequest.properties.beratungverz;
            },
            set(value) {
                this.$store.commit('work/SET_PROP_BERATUNGVERZICHT', value);
            }
        },
        werbung: {
            get() {
                return this.$store.state.work.forxchange.offerRequest.properties.werbung;
            },
            set(value) {
                this.$store.commit('work/SET_PROP_WERBUNG', value);
            }
        },
        agb: {
            get() {
                return this.$store.state.work.forxchange.offerRequest.properties.agb;
            },
            set(value) {
                this.$store.commit('work/SET_PROP_AGB', value);
            }
        },
        salesagent_nr: {
            get() {
                return this.$store.state.work.forxchange.offerRequest.contract.salesagent_nr;
            },
            set(value) {
                this.$store.commit('work/SET_SALESAGENT_NR_SUBSEQUENTLY', value);
            }
        },
        askForSalesAgentNr() {
            return (this.isOnlineGs && this.salesagent_nr_raw === "");
        },
        showSalesAgentNr() {
            return (this.isOnlineGs && this.salesagent_nr_raw.length > 0);
        },
        ...mapGetters("work", {
            selectedAgency: "getSelectedAgency",
            isOnlineGs: "getIsOnlineGs",
            salesagent_nr_raw: "getSalesAgentNrRaw",
            dataForDocumentService: "getExportDataForDocumentService"
        })
    },
    methods: {
        doIt() {
            createMyPdf(this.enrichedDocumentDefinition());
        },
        enrichedDocumentDefinition() {
            let template = JSON.stringify(documentDefinition);
            const content = this.dataForDocumentService;
            // policyHeader
            template = template.replaceAll("__vnr__", content.offerRequest.contract.policy);
            template = template.replaceAll("__name__", content.offerRequest.policyholder.name);
            template = template.replaceAll("__lastname__", content.offerRequest.policyholder.lastname);
            template = template.replaceAll("__street__", content.offerRequest.policyholder.street);
            template = template.replaceAll("__housenr__", content.offerRequest.policyholder.housenr);
            template = template.replaceAll("__zip__", content.offerRequest.policyholder.zip);
            template = template.replaceAll("__city__", content.offerRequest.policyholder.city);
            // Allgemeine Vertragsangaben
            const now = parseISO(content.offerRequest.contract.beginn);
            const nowString = now.toLocaleDateString("de-DE");
            template = template.replaceAll("__beginn__", nowString);
            const ende = add(now, { years: 1 });
            const endeString = ende.toLocaleDateString("de-DE");
            template = template.replaceAll("__ende__", endeString);
            let payDay = format(now, 'd');
            if (payDay === '29' || payDay === '30' || payDay === '31') {
                payDay += ", bzw. am Monatsende, falls der Monat weniger Tage hat";
            }
            template = template.replaceAll("__trueBeginDateDay__", payDay);

            const check = this.createProductsTableDefinitions(
                content.offerRequest.contract.products
            );
            // console.log("contract.products: ", content.offerRequest.contract.products);
            // console.log("Produkte: ", JSON.stringify(check));
            template = template.replaceAll(
                "__selectedProducts__",
                JSON.stringify(check)
            );
            // cleanup
            template = template.replaceAll('"[[{', '[[{');
            template = template.replaceAll('}]]"', '}]]');
            // Tabellenwerte Beitragsberechnung
            const beitragBrutto = content.offerRequest.contract.gesamtbeitrag;
            const beitragNetto = Math.round(100 * (beitragBrutto / 1.19)) / 100;
            const versSteuer = Math.round(100 * (beitragBrutto - beitragNetto)) / 100;
            template = template.replaceAll("__beitragNetto__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(beitragNetto));
            template = template.replaceAll("__versSteuer__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(versSteuer));
            template = template.replaceAll("__beitragBrutto__", new Intl.NumberFormat('de-DE', { minimumFractionDigits: 2 }).format(beitragBrutto));
            // Beitragsabrechnung
            // Ergänze Beginndatum, Folgedatum, FolgeFolgeDatum
            const folgeDatum = add(now, { months: 1 });
            const folgeFolgeDatum = add(folgeDatum, { months: 1 });
            const folgeDatumString = folgeDatum.toLocaleDateString("de-DE");
            const folgeFolgeDatumString = folgeFolgeDatum.toLocaleDateString("de-DE");

            template = template.replaceAll("__beginnDatum__", nowString);
            template = template.replaceAll("__folgeDatum__", folgeDatumString);
            template = template.replaceAll("__folgeFolgeDatum__", folgeFolgeDatumString);
            template = template.replaceAll("__IBAN__", this.obfuscateIban(content.offerRequest.policyholder.iban));

            // Ersetze den partner_id-Platzhalter mit dem tatsächlichen Wert, falls vorhanden
            if (content.offerRequest.policyholder.partnernummer) {
                template = template.replaceAll("__partner_id__", content.offerRequest.policyholder.partnernummer);
            } else if (content.offerRequest.policyholder.partner_id) {
                // Falls partner_id bereits existiert (z.B. nach Umbenennung)
                template = template.replaceAll("__partner_id__", content.offerRequest.policyholder.partner_id);
            } else {
                // Wenn keine partner_id vorhanden ist, entferne den Platzhalter
                template = template.replaceAll("__partner_id__", "");
            }

            const rich = JSON.parse(template);
            rich.footer = footerFunction;
            rich.header = headerFunction;
            return rich;
        },
        obfuscateIban(iban) {
            const lastFour = iban.substring(iban.length - 4);
            const firstFour = iban.substring(0, 4);
            let body = iban.substring(4, iban.length - 4);
            const obfuscated = body.replaceAll(/./g, "X");
            return firstFour + obfuscated + lastFour;
        },
        createProductsTableDefinitions(products) {
            let productsTableBody = [];
            products.forEach((product, index) => {
                productsTableBody.push([[], []]);
                productsTableBody[index][0] = {
                    text: [
                        { text: index + 1 + ". versicherter Gegenstand\n", bold: true },
                        { text: "Kategorie:\t" + product.label + "\nHersteller/Modell:\t" + product.producer }
                    ]
                };
                if (product.imei != "") {
                    productsTableBody[index][0].text.push({ text: "\nIMEI:\t" + product.imei });
                }
                productsTableBody[index][1] = {};
                if (product.pictures && product.pictures.length > 0) {
                    productsTableBody[index][1] = {
                        image: product.pictures[0].data,
                        fit: [50, 50]
                    };
                }
            });
            return productsTableBody;
        },
        // not new
        submitIfValid() {
            let ok = (this.beratungverz == true && this.agb == true);
            if (ok == true) {
                this.isSubmitting = true;
                this.submitOfferRequestForCheckService();
                postGaMessage('nextStep', 'Jetzt verbindlich abschließen: Angaben vollständig')
            }
            else {
                postGaMessage('nextStep', 'Jetzt verbindlich abschließen: Angaben unvollständig')
                if (this.beratungverz != true) {
                    this.showVerzichtRequiredDialog = true;
                    return;
                }
                if (this.agb != true) {
                    this.showAgbRequiredDialog = true;
                    return;
                }
            }
        },
        submitOfferRequestForCheckService() {
            // Eingabedaten (ohne Bilder) vom Check-Service prüfen lassen
            this.checkServiceRunning = true;
            let self = this;
            VisService.useCheckService()
                .then(function (response) {
                    self.checkServiceRunning = false;
                    self.$store.commit("work/SET_CHECK_IS_CALLED", true);
                    let answer = response.data;
                    if (answer.exceptions != undefined) {
                        console.error("Der Check-Service antwortet mit exceptions.");
                        self.errorMessage = answer.exceptions[0].message;
                        self.showErrorMessage = true;
                        self.isSubmitting = false;
                    }
                    else if ((answer.messages.length > 0) && (answer.error !== '')) {
                        console.error("else if Zweig: Fehlermeldung = " + answer.messages[0].message);
                        // TODO: Auswertung von messages.field und messages.type
                        self.errorMessage = answer.messages[0].message;
                        self.showErrorMessage = true;
                        self.isSubmitting = false;
                    }
                    else {
                        // Generate policy document
                        console.log("Störungsfreier Response. Jetzt: PDF generieren.");
                        self.$store.commit("work/IMPORT_CHECKSERVICE_RESPONSE", answer.offerRequest.contract);
                        if (answer.offerRequest.contract.policy != "") {
                            // self.submitOfferRequestForDocumentService();
                            self.createPdfData();
                        }
                    }
                }).catch(function (error) {
                    console.error("Fehler vom Check-Service gemeldet:", error);
                    self.checkServiceRunning = false;
                    // Fehlermeldung für den Nutzer
                    self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
                    self.showErrorMessage = true;
                    self.isSubmitting = false;
                });
        },
        createPdfData() {
            // console.log("PDF-Generierung: Start");
            const { vfs } = vfsFonts.pdfMake;
            pdfMake.vfs = vfs;
            pdfMake.fonts = {
                Brix: {
                    normal: 'BrixSansOfficeMedium-Regular.ttf',
                    bold: 'BrixSansOfficeMedium-Bold.ttf',
                    italics: 'BrixSansOfficeMedium-RegularItalic.ttf'
                }
            };
            // console.log("PDF-Generierung: Fonts geladen");
            const pdfDoc = pdfMake.createPdf(this.enrichedDocumentDefinition());
            // // console.log("PDF-Generierung: nach create ...");
            pdfDoc.getBase64((data) => {
                // console.log("PDF-Generierung: base64 erzeugt");
                this.$store.commit("work/SET_POLICY_DOCUMENT", data);
                // console.log("PDF-Generierung: state aktualisiert. Jetzt folgt Aufruf SendService");
                this.submitOfferRequestForSendService();
            });
        },

        testPolicy() {
            // console.log("PDF-Generierung: Start");
            const { vfs } = vfsFonts.pdfMake;
            pdfMake.vfs = vfs;
            pdfMake.fonts = {
                Brix: {
                    normal: 'BrixSansOfficeMedium-Regular.ttf',
                    bold: 'BrixSansOfficeMedium-Bold.ttf',
                    italics: 'BrixSansOfficeMedium-RegularItalic.ttf'
                }
            };
            // console.log("PDF-Generierung: Fonts geladen");
            const pdfDoc = pdfMake.createPdf(this.enrichedDocumentDefinition());
            pdfDoc.open();
        },
        submitOfferRequestForDocumentService() {
            // Generiere die Police
            this.sendServiceRunning = true;
            let self = this;
            PdfService.generatePolicyDocument(this.$store.getters['work/getExportDataForDocumentService'])
                .then(function (response) {
                    self.sendServiceRunning = false;
                    var file = new Blob([response.data], { type: 'application/pdf' });
                    const reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function () {
                        self.$store.commit("work/SET_POLICY_DOCUMENT", btoa(reader.result));
                        self.submitOfferRequestForSendService();
                    }
                }).catch(function (response) {
                    self.sendServiceRunning = false;
                    // Fehlermeldung für den Nutzer
                    console.error("Fehler von submitOfferRequestForDocumentService gemeldet:", response);
                    self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
                    self.showErrorMessage = true;
                });
        },
        isolatedSubmitOfferRequestForDocumentService() {
            // Für Testzwecke
            // this.$store.dispatch('work/generateTestData');
            this.sendServiceRunning = true;
            let self = this;
            PdfService.generatePolicyDocument(this.$store.getters['work/getExportDataForDocumentService'])
                .then(function (response) {
                    self.sendServiceRunning = false;
                    var file = new Blob([response.data], { type: 'application/pdf' });
                    const reader = new FileReader();
                    reader.readAsBinaryString(file);
                    reader.onload = function () {
                        self.$store.commit("work/SET_POLICY_DOCUMENT", file);
                        // Window öffnen
                        var testfile = self.$store.state.work.forxchange.offerRequest.document.data;
                        var testfileURL = URL.createObjectURL(testfile);
                        window.open(testfileURL);
                    }
                }).catch(function (response) {
                    self.sendServiceRunning = false;
                    // Fehlermeldung für den Nutzer
                    console.error("Fehler von isolatedSubmitOfferRequestForDocumentService gemeldet:", response);
                    self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
                    self.showErrorMessage = true;
                });
        },
        submitOfferRequestForSendService() {
            // Alle Daten an /VierGewinntMiddleTier/rest/callVierGewinntMiddleTierCheckService übermitteln
            // Response auswerten. Wenn ok, dann:
            // Daten an /VierGewinntMiddleTier/rest/callVierGewinntMiddleTierSendService übermitteln
            this.sendServiceRunning = true;
            let self = this;
            let test = this.$store.getters['work/getExportDataForSendService'];
            VisService.useSendService(this.$store.getters['work/getExportDataForSendService'])
                .then(function (response) {
                    self.sendServiceRunning = false;
                    let answer = response.data;
                    if (answer.exceptions !== undefined && answer.exceptions.length > 0) {
                        // TODO: Auswertung von messages.field und messages.type
                        self.errorMessage = answer.exceptions[0].message;
                        self.showErrorMessage = true;
                        self.isSubmitting = false;
                    }
                    else {
                        // SUCCESS
                        self.$store.commit("work/SET_CONTRACT_ACCEPTANCE_STATE", true);    // Löst via vuex die Erfolgsmeldung aus
                        self.$emit('contractSuccess');      // Elternkomponente informieren, damit sie sich schließt
                        self.resetProductSelection();
                    }
                }).catch(function (error) {
                    self.sendServiceRunning = false;
                    // Fehlermeldung für den Nutzer
                    console.error("Fehler vom Send-Service gemeldet:", error);
                    self.errorMessage = "Ihre Angaben konnten aus technischen Gründen leider nicht übermittelt werden. Bitte versuchen Sie es später erneut oder wenden Sie sich an unseren telefonischen Kundenservice unter (0531) 202-0.";
                    self.showErrorMessage = true;
                    self.isSubmitting = false;
                });
        },
        resetProductSelection() {
            this.$store.dispatch("work/deleteProduct", 0);
            this.$store.dispatch("work/deleteProduct", 0);
            this.$store.dispatch("work/deleteProduct", 0);
            this.$store.dispatch("work/deleteProduct", 0);
        }
    }
}
</script>

<style>
div.v-card.agency-card {
    width: 100%;
}

.subcard-header,
.subcard-header .v-icon {
    color: #002EA7 !important;
    background-color: #ccd5ed !important;
}

.subcard-header .v-icon {
    font-size: larger;
}

.v-label {
    font-size: 14px !important;
    color: inherit !important;
}

a {
    text-decoration: none;
}

.text-smaller {
    font-size: smaller !important;
}

p.subheading {
    font-weight: bold;
}

.bold-placeholder input[type="text"]::placeholder {
    font-weight: bold;
}
</style>
